import Icon from '@/components/common/icons/Icon';
import IconBackground from '@/components/common/icons/IconBackground';
import { FlexProps } from '@chakra-ui/react';
import { TransactionEntryCategoryFieldsFragment } from '@common/graphql/generated';
import { getIconColor } from '@common/react/cashflow';

interface CategoryIconProps {
    category: Pick<
        TransactionEntryCategoryFieldsFragment,
        'iconName' | 'categoryGroup'
    >;
    size?: FlexProps['w'];
    withBackground?: boolean;
    color?: string;
}

const CategoryIcon = ({
    category,
    size = 'sm',
    withBackground = true,
    color = 'black',
}: CategoryIconProps) => {
    const { iconName } = category;
    const bgColor = getIconColor(category.categoryGroup.name);

    if (!withBackground) {
        return <Icon name={iconName} color={color} size={size} />;
    }

    return (
        <IconBackground bg={bgColor} size={size}>
            <Icon name={iconName} color={color} size={size} />
        </IconBackground>
    );
};

export default CategoryIcon;
